























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AllocationNavigation extends Vue {
  @Prop({ required: true }) public readonly active!: string;

  public clearPointerFocus(event: MouseEvent): void {
    if (event.detail > 0 && event.currentTarget instanceof HTMLElement) {
      event.currentTarget.blur();
    }
  }

  get production() {
    return {
      name: "ProductAllocationEditPage",
      query: { slotType: "production" },
    };
  }

  get design() {
    return { name: "ProductAllocationEditPage", query: { slotType: "design" } };
  }
}
